module.exports = __webpack_public_path__ + "img/product-5.35cc1a2b.jpeg";